import { Flex, Inline } from "@/ui/components/layout";
import { PolaroidImage } from "@/ui/components/primitives";
import { TextBody } from "@/ui/components/typography";
import { FC } from "react";
import { TTestimonialProps } from "./Testimonial.config";
import { TextControl } from "@/ui/components/typography/TextControl";
import { Blockquote } from "@/ui/components/layout/Blockquote/Blockquote";
import { Stars } from "@/ui/components/sections/marketing/social-proof/Stars";

export const Testimonial: FC<TTestimonialProps> = ({
  review,
  author,
  image,
  stars = 5,
}) => {

  return(
    <figure
      data-component="Testimonial"
      className="p-2 border border-solid border-black rounded-sys-xs"
    >
      <Inline>
        <PolaroidImage image={image} size="sm" className="w-32" />
        <Flex direction="column" gap="2">
          <Blockquote>
            <TextControl size={3} isResponsive={false}>{ review }</TextControl>
          </Blockquote>
          <figcaption>
            <Inline gap="2">
              { stars ? (
                <div className="w-20">
                  <Stars stars={stars} />
                </div>
              ): null }
              <TextBody tag="span" size={4}>{ author }</TextBody>
            </Inline>
          </figcaption>
        </Flex>
      </Inline>
    </figure>
  );
};
